import { IconProps } from "types/icon"

const QrCode = ({ size = "22", ...props }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      aria-hidden
      {...props}
    >
      <rect x="0.75" y="0.75" width="3.5" height="3.5" rx="0.5" stroke="#52525B" strokeWidth="1.2" />
      <rect x="2" y="2" width="1.25" height="1.25" fill="#52525B" />
      <rect x="7.75" y="0.75" width="3.5" height="3.5" rx="0.5" stroke="#52525B" strokeWidth="1.2" />
      <rect x="9" y="2" width="1.25" height="1.25" fill="#52525B" />
      <rect x="0.75" y="7.75" width="3.5" height="3.5" rx="0.5" stroke="#52525B" strokeWidth="1.2" />
      <rect x="2" y="9" width="1.25" height="1.25" fill="#52525B" />
      <rect x="5.5" y="5.5" width="1.25" height="1.25" fill="#52525B" />
      <rect x="7.25" y="7.25" width="1.25" height="1.25" fill="#52525B" />
      <rect x="9.75" y="5.5" width="1.25" height="1.25" fill="#52525B" />
      <rect x="5.5" y="9.75" width="1.25" height="1.25" fill="#52525B" />
      <rect x="9.75" y="9.75" width="1.25" height="1.25" fill="#52525B" />
    </svg>
  )
}

export default QrCode
